import { isDocSyncUnavailable } from '@affine/nbstore/frontend';
export interface SyncEngineState {
  syncRetrying: boolean;
  syncErrorMessage: string | null;
  syncIsolatedFailure?: unknown | null;
}

export function shouldShowGlobalSyncRetryStatus(
  state: SyncEngineState | null | undefined
): boolean {
  return (
    state != null &&
    state.syncRetrying === true &&
    state.syncIsolatedFailure == null
  );
}

export function shouldShowGlobalSyncOfflineBanner(
  state: SyncEngineState | null | undefined,
  docSyncWasEstablished: boolean
): boolean {
  return (
    shouldShowGlobalSyncRetryStatus(state) &&
    docSyncWasEstablished &&
    isDocSyncUnavailable(state)
  );
}

/** The server refused this app's sync protocol for the workspace; shown until
 * the app is updated. */
export function isSyncProtocolUnsupported(
  refusal: { readonly workspaceId: string } | null | undefined,
  workspaceId: string
): boolean {
  return refusal?.workspaceId === workspaceId;
}
